import { ViewIds } from '@ardoq/api-types';
import { combineLatest, distinctUntilChanged, map } from 'rxjs';
import { isEqual } from 'lodash';
import { type ObservableState, toPersistentStream } from '@ardoq/rxbeach';
import {
  MAIN_PANE_LEFT,
  MAIN_PANE_RIGHT,
  PaneLocation,
} from 'streams/views/mainContent/types';
import { type ModeViews, workspaceModeViews$ } from 'views/modeViews$';
import { WorkspaceModeViewKey } from 'views/environmentals/viewSettings/types';
import { MainViewTab, TabOptions } from './types';
import {
  leftTabOptions$,
  rightTabOptions$,
} from './getTabOptionsStreamWithLocation';

export type WorkspaceModeViewPaneTab = MainViewTab & {
  location: PaneLocation;
  activeTabId: WorkspaceModeViewKey | ViewIds.NONE;
};

const sanitizeTab = (
  location: PaneLocation,
  { activeTabId }: TabOptions,
  { byIds }: ModeViews<ViewIds>
): WorkspaceModeViewPaneTab => ({
  location,
  activeTabId,
  metaInfo: byIds[activeTabId] ?? null,
});

const getWorkspaceModeViewPaneTab$ = (
  location: PaneLocation,
  tabOptions$: ObservableState<TabOptions>
): ObservableState<WorkspaceModeViewPaneTab> =>
  toPersistentStream(
    `${location}WorkspaceModeViewPaneTab$`,
    combineLatest([tabOptions$, workspaceModeViews$]).pipe(
      map(([tabOptions, views]) => sanitizeTab(location, tabOptions, views)),
      distinctUntilChanged(isEqual)
    ),
    { location, activeTabId: ViewIds.NONE, metaInfo: null }
  );

export const leftWorkspaceModeViewPaneTab$ = getWorkspaceModeViewPaneTab$(
  MAIN_PANE_LEFT,
  leftTabOptions$
);

export const rightWorkspaceModeViewPaneTab$ = getWorkspaceModeViewPaneTab$(
  MAIN_PANE_RIGHT,
  rightTabOptions$
);
